import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { useMediaQuery, useTheme } from '@mui/material'

import { TextEditor, HelperWrapper } from 'src/components'
import { DescriptionGenerateButton } from './description-generate-btn.component'
import { AIGenerateContentPrompt, IProductForm } from 'src/types'

interface IProps {
  isDisabled?: boolean
  locale?: string
  isRequired?: boolean
  textPrompt?: string
  generationType?: AIGenerateContentPrompt
}

export const DescriptionRichInput = ({
  isDisabled,
  locale,
  isRequired = true,
  textPrompt,
  generationType,
}: IProps) => {
  const [t] = useTranslation()
  const theme = useTheme()

  const { values, setFieldValue, errors } = useFormikContext<IProductForm>()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleTextEditor = (value: string, _delta: any, source: string) => {
    if (source === 'user') {
      setFieldValue('description', value)
    }
  }

  if (!(values.description && values.description.substring(0, 3) === '<p>')) {
    values.description = `<p>${values.description ?? ''}</p>`
  }
  return (
    <>
      <TextEditor
        isDisabled={isDisabled}
        label={
          <HelperWrapper
            t="description-input-label"
            verticalPosition={isTablet ? 10 : 15}
            size={isTablet ? 11 : 12}
            isColorInherited
            isMandatory={isRequired}
          />
        }
        value={values.description}
        handleChange={handleTextEditor}
        error={errors.description ? t(errors.description + '.v') : undefined}
      />
      <DescriptionGenerateButton
        locale={locale}
        textPrompt={textPrompt}
        generationType={generationType}
        iSIndentTop
      />
    </>
  )
}
